export default "__VITE_ASSET__BoEIc3d2__"